var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarehouses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-warehouses",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.819,
    height: 35.532,
    viewBox: "0 0 34.819 35.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "school",
    d: "M34.5,18.422,30.925,13.43a1.506,1.506,0,0,0-1.2-.632H21.066l-2.18-2.957V8.112h6.865a1.506,1.506,0,0,0,1.2-2.409L25.722,4.059l1.235-1.65A1.506,1.506,0,0,0,25.752,0H17.387a1.5,1.5,0,0,0-1.506,1.506V9.841L13.695,12.8H5.071a1.506,1.506,0,0,0-1.2.632l-3.6,4.993a1.506,1.506,0,0,0,1.2,2.409h.867V34.08a1.506,1.506,0,0,0,1.506,1.451h27.1a1.506,1.506,0,0,0,1.506-1.506V20.777H33.3a1.506,1.506,0,0,0,1.343-.819A1.53,1.53,0,0,0,34.5,18.422Zm-24.493-.6H4.421l1.421-1.987h5.631Zm10.666,14.1H14.092v-4.6a3.294,3.294,0,1,1,6.582,0ZM24.758,17.8l-1.463-1.987h5.631L30.347,17.8Z",
    transform: "translate(0.03 0)",
    fill: "#ffffff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarehouses);
export default __webpack_public_path__ + "static/media/icon-warehouses.697bcc667126a1e167e1b8680d3e1799.svg";
export { ForwardRef as ReactComponent };